// extracted by mini-css-extract-plugin
export default {"row":"Row_row__dUuPq","number":"Row_number__5icCp","status":"Row_status__xy00i","col":"Row_col__jpnfr","item":"Row_item__joGJz"};